import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const UserIcon = (props) => {
  return (
    <svg version="1.0"
 width="16.000000pt" height="16.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  fill="#000000" stroke="none">
  <path d="M2330 5110 c-494 -48 -950 -230 -1350 -538 -195 -150 -448 -432 -594
    -662 -63 -99 -186 -351 -230 -471 -421 -1149 41 -2445 1097 -3078 414 -248
    913 -376 1397 -357 533 20 1028 196 1460 519 126 95 377 346 476 477 488 645
    650 1442 449 2209 -48 180 -92 297 -180 476 -132 269 -269 460 -489 681 -221
    220 -412 357 -681 489 -246 121 -474 193 -740 235 -147 23 -475 34 -615 20z
    m570 -185 c678 -100 1284 -488 1662 -1065 81 -124 192 -345 243 -484 48 -130
    99 -332 121 -481 22 -143 25 -480 6 -620 -40 -293 -117 -545 -241 -788 -57
    -114 -177 -307 -190 -307 -4 0 -15 24 -25 53 -64 183 -221 444 -371 618 -191
    220 -473 429 -716 530 -41 17 -76 33 -78 35 -2 2 20 29 49 61 120 131 226 317
    269 473 105 376 -8 798 -286 1072 -43 43 -103 96 -133 119 -82 61 -262 145
    -375 176 -90 24 -117 27 -275 27 -158 0 -185 -3 -275 -27 -113 -31 -293 -115
    -375 -176 -30 -23 -90 -76 -133 -119 -278 -274 -391 -696 -286 -1072 43 -156
    149 -342 269 -473 29 -32 51 -59 49 -61 -2 -2 -37 -18 -78 -35 -250 -104 -543
    -324 -732 -549 -146 -175 -293 -423 -355 -600 -10 -28 -21 -52 -25 -52 -13 0
    -133 193 -190 307 -124 243 -201 495 -241 788 -19 140 -16 477 6 620 39 258
    110 485 226 721 365 741 1083 1237 1915 1323 127 14 429 6 565 -14z m-169
    -761 c338 -64 621 -315 723 -643 158 -505 -140 -1044 -654 -1183 -123 -33
    -357 -33 -480 0 -514 139 -812 678 -654 1183 140 450 605 730 1065 643z m-673
    -1908 c162 -81 321 -119 502 -119 181 0 340 38 502 119 37 19 75 34 85 34 10
    0 67 -20 126 -44 502 -205 899 -633 1071 -1154 l28 -82 -31 -38 c-39 -50 -198
    -201 -287 -274 -245 -199 -580 -369 -887 -447 -414 -106 -800 -106 -1214 0
    -306 78 -643 248 -887 447 -89 73 -248 224 -287 274 l-31 38 28 82 c147 445
    459 825 871 1057 96 55 295 141 326 141 10 0 48 -15 85 -34z"/>
</g>
</svg>

  );
};

export default UserIcon;
